import React, { Component } from "react";
import { message, Upload, Select, Spin, Tag } from "antd";
import axios from "axios";
import { ButtonItem, InputItem, InputNumberItem, TableItem, SelectItem } from "./Items";
import SelectInsumosItem from "./SelectInsumosItem";
import { UploadOutlined, DownloadOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  ETIQUETAS_ESTADO_CLAVE,
  aplicarResultadosClaves,
  avisoRepetidoInsumoCliente,
  contarIdentidades,
  descargarPlantillaInsumosCliente,
  esArchivoExcel,
  formatoUnidad,
  identidadInsumoCliente,
  leerFilasExcelInsumosCliente,
  normalizar,
  resolverUnidadesDeFilas,
} from "./excelInsumosCliente";

const { Option } = Select;

class SeccionSubirInsumosCliente extends Component {
  state = {
    filas: [],
    archivosExcel: [],
    procesando: false,
    objetoUnidades: [],
    todasUnidades: [],
    descargandoPlantilla: false,
  };

  componentDidMount() {
    axios
      .post("unidades/selectUnidades", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (Array.isArray(res.data)) {
          this.setState({
            todasUnidades: res.data,
            objetoUnidades: res.data.map((value) => (
              <Option value={value._id} key={value._id}>
                {value.unidadSat.c_ClaveUnidad + " - " + value.nombre}
              </Option>
            )),
          });
        }
      });
  }

  descargarPlantilla = () => {
    this.setState({ descargandoPlantilla: true });
    const unidades = this.state.todasUnidades.map(formatoUnidad).filter(Boolean);
    axios
      .post(
        "insumos/catalogoVentaParaPlantillaInsumosCliente",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        descargarPlantillaInsumosCliente(res.data.success === 2 ? res.data.catalogo : [], unidades);
      })
      .catch(() => {
        message.warning("No se pudo traer el catálogo para la plantilla; se descargó sin la hoja de referencia.");
        descargarPlantillaInsumosCliente(undefined, unidades);
      })
      .finally(() => this.setState({ descargandoPlantilla: false }));
  };

  onChangeArchivo = (e) => {
    if (!esArchivoExcel(e.file)) {
      message.error("El archivo debe ser un archivo de excel (.xlsx)");
      return;
    }
    this.setState({
      procesando: true,
      archivosExcel: [{ ...e.file, name: e.file.name, status: "uploading", response: "Cargando" }],
    });
    this.cargarArchivoExcel(e.file);
  };

  cargarArchivoExcel(file) {
    leerFilasExcelInsumosCliente(file)
      .then((filas) =>
        this.procesarFilas(filas, file).catch((errorProcesar) => {
          console.log(errorProcesar);
          message.error("No se pudo procesar el archivo");
          this.setState({ procesando: false });
        })
      )
      .catch((err) => {
        console.log(err);
        message.error("No se pudo leer el archivo");
        this.setState({ procesando: false });
      });
  }

  async procesarFilas(filas, file) {
    const terminar = (filasFinales) =>
      this.setState({
        filas: filasFinales,
        procesando: false,
        archivosExcel: [{ ...file, name: file.name, status: "success" }],
      });

    if (filas.length === 0) {
      message.warning("El archivo no tiene filas para procesar (falta la columna 'Nombre para el Cliente')");
      return terminar(filas);
    }

    const unidadesPorTexto = new Map(
      this.state.todasUnidades.map((u) => [normalizar(formatoUnidad(u)), u._id]).filter(([texto]) => texto)
    );
    const filasConUnidad = resolverUnidadesDeFilas(filas, unidadesPorTexto);

    const hayClaveOTexto = filasConUnidad.some((fila) => fila.claveInsumo || fila.descripcionInsumo);

    if (!hayClaveOTexto) {
      message.info(`${filasConUnidad.length} fila(s) cargada(s). Elige el insumo (y la unidad si aplica) en cada una.`);
      return terminar(filasConUnidad);
    }

    let resultados;
    try {
      const res = await axios.post(
        "insumos/resolverClavesInsumosVentaMasivo",
        {
          empresaId: this.props.empresaId,
          filas: filasConUnidad.map((fila) => ({ clave: fila.claveInsumo, descripcion: fila.descripcionInsumo })),
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success !== 2) throw new Error(res.data.message);
      resultados = res.data.resultados || [];
    } catch (err) {
      console.log(err);
      message.warning(`${filasConUnidad.length} fila(s) cargada(s), pero no se pudieron buscar las claves de insumo. Elige el insumo en cada una.`);
      return terminar(filasConUnidad);
    }

    const filasResueltas = aplicarResultadosClaves(filasConUnidad, resultados);
    const asignadas = filasResueltas.filter((fila) => fila.insumoId).length;
    const pendientes = filasResueltas.length - asignadas;
    message.info(
      `${filasResueltas.length} fila(s) cargada(s), ${asignadas} con insumo asignado automaticamente` +
      (pendientes > 0 ? `, ${pendientes} pendiente(s) por elegir a mano.` : ".")
    );
    return terminar(filasResueltas);
  }

  actualizarFila(index, cambios) {
    this.setState((prev) => ({
      filas: prev.filas.map((fila, i) => (i === index ? { ...fila, ...cambios } : fila)),
    }));
  }

  eliminarFila(index) {
    this.setState((prev) => ({ filas: prev.filas.filter((_, i) => i !== index) }));
  }

  confirmar = () => {
    const { filas } = this.state;
    const validas = filas.filter((fila) => fila.insumoId && fila.nombreAlternativo?.trim());
    if (validas.length === 0) {
      return message.warning("No hay filas listas para confirmar (falta elegir el insumo o el nombre para el cliente)");
    }
    this.props.onConfirmar(validas, () => this.setState({ filas: [], archivosExcel: [] }));
  };

  render() {
    const { empresaId, headersToken, loading, insumosYaConfigurados } = this.props;
    const { filas, archivosExcel, procesando, objetoUnidades, descargandoPlantilla } = this.state;

    const hayClavesInsumo = filas.some((fila) => fila.claveInsumo);
    // Repetir un insumo está permitido (otra clave, otra presentación, otro precio de
    // contrato), así que sólo se avisa. Se cuenta una vez por render y no por renglón.
    const yaConfigurados = new Set((insumosYaConfigurados || []).map((id) => String(id)));
    const conteoIdentidades = contarIdentidades(filas);

    const columns = [
      ...(hayClavesInsumo ? [{
        title: "Clave Insumo",
        dataIndex: "claveInsumo",
        key: "claveInsumo",
        width: 140,
        render: (value, record) => {
          const etiqueta = record.estadoClave && ETIQUETAS_ESTADO_CLAVE[record.estadoClave];
          return (
            <>
              <div>{value || "-"}</div>
              {etiqueta && <Tag color={etiqueta.color} style={{ marginTop: 2 }}>{etiqueta.texto}</Tag>}
            </>
          );
        },
      }] : []),
      {
        title: "Insumo",
        dataIndex: "insumoId",
        key: "insumoId",
        width: 240,
        render: (_, record, index) => {
          if (record.estadoClave === "AMBIGUO" && record.candidatos?.length) {
            return (
              <div>
                <Tag color="orange" style={{ marginBottom: 2 }}>Ambiguo</Tag>
                <SelectItem
                  sinBorde
                  width="100%"
                  placeholder="Elegir insumo"
                  onChange={(valor) => {
                    const candidato = record.candidatos.find(
                      (c) => String(c.equivalenciaId || c._id) === String(valor)
                    );
                    if (!candidato) return;
                    this.actualizarFila(index, {
                      insumoId: String(candidato._id),
                      equivalenciaId: candidato.equivalenciaId ? String(candidato.equivalenciaId) : undefined,
                      claveInterna: candidato.clave,
                      descripcion: candidato.descripcion,
                      unidadId: record.unidadId || candidato.unidadId,
                      stringBuscar: [candidato.clave, candidato.descripcion, candidato.unidadNombre].filter(Boolean).join(" - "),
                      estadoClave: undefined,
                      candidatos: undefined,
                    });
                  }}
                >
                  {record.candidatos.map((candidato) => (
                    <Option
                      value={String(candidato.equivalenciaId || candidato._id)}
                      key={String(candidato.equivalenciaId || candidato._id)}
                    >
                      {[candidato.clave, candidato.descripcion, candidato.unidadNombre].filter(Boolean).join(" - ")}
                      {candidato.equivalenciaId ? " (presentación)" : ""}
                    </Option>
                  ))}
                </SelectItem>
              </div>
            );
          }

          const avisoRepetido = avisoRepetidoInsumoCliente(
            identidadInsumoCliente(record),
            yaConfigurados,
            conteoIdentidades
          );
          const valorSeleccionado = record.equivalenciaId || record.insumoId;
          return (
            <>
            {avisoRepetido && <Tag color="gold" style={{ marginBottom: 2 }}>{avisoRepetido}</Tag>}
            <SelectInsumosItem
              empresaId={empresaId}
              headersToken={headersToken}
              tiposInsumos="venta"
              sinBorde
              width="100%"
              placeholder="Buscar insumo"
              value={valorSeleccionado}
              insumoPreCargado={valorSeleccionado ? { _id: valorSeleccionado, stringBuscar: record.stringBuscar || `${record.claveInterna || ""} - ${record.descripcion || ""}` } : null}
              onChange={(value, insumo) => {
                this.actualizarFila(index, {
                  insumoId: insumo?.noPrincipal ? insumo.insumoPrincipalId : value,
                  equivalenciaId: insumo?.noPrincipal ? value : undefined,
                  claveInterna: insumo?.clave,
                  descripcion: insumo?.descripcion,
                  stringBuscar: insumo?.stringBuscar,
                  estadoClave: undefined,
                });
              }}
            />
            </>
          );
        },
      },
      {
        title: "Nombre para el cliente",
        dataIndex: "nombreAlternativo",
        key: "nombreAlternativo",
        width: 180,
        render: (value, record, index) => (
          <InputItem sinBorde placeholder="Nombre para el cliente" value={value} onChange={(e) => this.actualizarFila(index, { nombreAlternativo: e.target.value })} />
        ),
      },
      {
        title: "Clave Cliente",
        dataIndex: "clave",
        key: "clave",
        width: 120,
        render: (value, record, index) => (
          <InputItem sinBorde placeholder="Clave" value={value} onChange={(e) => this.actualizarFila(index, { clave: e.target.value })} />
        ),
      },
      {
        title: "Precio Unitario",
        dataIndex: "precio",
        key: "precio",
        width: 110,
        render: (value, record, index) => (
          <InputNumberItem dinero sinBorde placeholder="Precio Unitario" value={value} onChange={(v) => this.actualizarFila(index, { precio: v })} />
        ),
      },
      {
        title: "Presentación",
        dataIndex: "presentacion",
        key: "presentacion",
        width: 140,
        render: (value, record, index) => (
          <InputItem sinBorde placeholder="Ej. Caja 24 pz" value={value} onChange={(e) => this.actualizarFila(index, { presentacion: e.target.value })} />
        ),
      },
      {
        title: "Unidad",
        dataIndex: "unidadId",
        key: "unidadId",
        width: 160,
        render: (value, record, index) => (
          <SelectItem sinBorde placeholder="Unidad SAT" value={value} onChange={(v) => this.actualizarFila(index, { unidadId: v })}>
            {objetoUnidades}
          </SelectItem>
        ),
      },
      {
        title: "Conversión",
        dataIndex: "conversion",
        key: "conversion",
        width: 90,
        render: () => <InputNumberItem sinBorde disabled value={1} />,
      },
      {
        title: "",
        dataIndex: "acciones",
        key: "acciones",
        width: 50,
        render: (_, record, index) => (
          <ButtonItem size="small" danger icon={<DeleteOutlined />} onClick={() => this.eliminarFila(index)} />
        ),
      },
    ];

    return (
      <Spin spinning={!!loading || procesando}>
        <div
          style={{
            border: "1px dashed #d9d9d9",
            backgroundColor: "#fafafa",
            borderRadius: 6,
            padding: 16,
            marginBottom: 16,
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <ButtonItem
            icon={<DownloadOutlined />}
            type="primary"
            verde
            loading={descargandoPlantilla}
            onClick={this.descargarPlantilla}
          >
            Descargar Plantilla
          </ButtonItem>
          <Upload
            showUploadList={{ showRemoveIcon: false, showPreviewIcon: false }}
            fileList={archivosExcel}
            customRequest={this.onChangeArchivo}
            accept=".xlsx"
            maxCount={1}
          >
            <ButtonItem icon={<UploadOutlined />} cyan>Subir Archivo</ButtonItem>
          </Upload>
        </div>

        {filas.length > 0 && (
          <>
            <TableItem
              size="small"
              dataSource={filas}
              columns={columns}
              rowKey={(_, index) => index}
              defaultPageSize={50}
            />
            <div style={{ display: "flex", justifyContent: "right", marginTop: 10 }}>
              <ButtonItem type="primary" onClick={this.confirmar}>
                Confirmar
              </ButtonItem>
            </div>
          </>
        )}
      </Spin>
    );
  }
}

export default SeccionSubirInsumosCliente;
